import { z } from "zod";

function requiredTrimmedString(message: string) {
  return z.string().trim().min(1, message);
}

const optionalTrimmedString = z.string().trim();

const WEBSITE_HOSTNAME_PATTERN =
  /^(?:[\da-z](?:[\da-z-]*[\da-z])?\.)+[a-z]{2,}$/iu;

function parseOptionalWebsiteUrl(value: string): URL | null {
  const trimmed = value.trim();

  if (!trimmed) {
    return null;
  }

  const candidate = trimmed.includes("://") ? trimmed : `https://${trimmed}`;

  if (!URL.canParse(candidate)) {
    return null;
  }

  return new URL(candidate);
}

function isValidWebsiteHostname(hostname: string): boolean {
  if (hostname === "localhost") {
    return true;
  }

  return WEBSITE_HOSTNAME_PATTERN.test(hostname);
}

function isValidOptionalUrl(value: string): boolean {
  if (!value) {
    return true;
  }

  const parsedUrl = parseOptionalWebsiteUrl(value);

  if (!parsedUrl) {
    return false;
  }

  return isValidWebsiteHostname(parsedUrl.hostname);
}

const optionalWebsite = optionalTrimmedString.refine(isValidOptionalUrl, {
  message: "Enter a valid website URL",
});

export {
  optionalTrimmedString,
  optionalWebsite,
  requiredTrimmedString,
};
